import React, { Fragment } from "react";
import AircraftsContent from "../components/aircrafts/aircrafts-content";

const Aircrafts = () => {
  return <AircraftsContent />;
};

export default Aircrafts;
